import styled from 'styled-components'

import theme from 'configs/theme'

const Styled = styled.div`
  .page-header {
    .title-block {
      h1 {
        margin-bottom: 0;
      }
    }

    .search-block {
      .ant-input-group-wrapper {
        border-radius: 8px;
        overflow: hidden;

        .ant-input-wrapper {
          border: 0;

          .ant-input {
            border: 0;
            height: 40px;

            &:focus {
              box-shadow: none;
            }

            &::placeholder {
            }
          }

          .ant-input-group-addon {
            border: 0;
            background-color: #ffffff;
            padding: 0 4px;

            .ant-input-search-button {
              background-color: ${theme['@primary-color']};
              width: 30px;
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 6px;

              span {
                color: #ffffff;
                font-size: 16px;
              }
            }
          }
        }
      }
    }

    .account-block {
      display: flex;
      align-items: center;

      .icon-block {
        span {
          font-size: 26px;
          color: ${theme['@primary-color']};
        }
      }
      .name-block {
        margin: 0 10px;

        .name {
        }
        .role {
          span {
            font-size: 12px;
          }
        }
        .profile {
          span {
            font-size: 12px;
          }
        }
      }
      .avatar-block {
      }
    }
  }

  .page-content {
  }
`

export default Styled
